import { Text, Box, Image, Icon } from '@chakra-ui/react';
import StepperContext from '../contexts/StepperContext';
import MerchantContext from '../contexts/MerchantContext';
import InvoiceDataContext from '../contexts/InvoiceDataContext';
import { useContext } from 'react';

const PaymentMethodElement = (): JSX.Element => {
  const { paymentMethodContext } = useContext(StepperContext);
  const { paymentMethod } = paymentMethodContext;
  const { merchant } = useContext(MerchantContext);
  const { cardFeePercentage } = useContext(InvoiceDataContext);

  const isCard = paymentMethod?.id === 'card';

  return (
    <Box>
      <Text fontWeight={600}>Método de pago</Text>
      <Box
        display={'flex'}
        flexDirection={'row'}
        py={2}
        px={4}
        justifyContent={'space-between'}
        alignItems={'center'}
        border={'1px solid #DFDEE2'}
        borderRadius={'6px'}
      >
        <Text variant={'circular'} fontWeight={600}>
          {paymentMethod!.paymentMethod}
        </Text>
        <Image boxSize={'32px'} src={paymentMethod!.imageUrl} />
      </Box>
      {isCard && cardFeePercentage && (
        <Box display={'flex'} flexDirection={'row'} alignItems={'flex-start'} pt={2} gap={2}>
          <Icon color={'rentals.states.processing'} boxSize={4} mt={1} />
          <Text fontSize={'0.875rem'}>
            {merchant?.cardFeeMessage ||
              `El costo adicional cubre comisiones bancarias y retenciones de ley. No representa ingresos para la inmobiliaria.`}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default PaymentMethodElement;
